@if (folders && folders.length > 0) {
  <div class="documents-folders">
    @for (folder of folders; track $index) {
      <div class="folder">
        @if (!hideDropdownMenu) {
          <div class="folder-option" appDropdown placement="bottom-right">
            <button type="button" class="dropdown__toggle-control dropdown__toggle-control--corner dropdown__toggle-control--icon-only" appDropdownToggle (click)="loadFolderEditor(folder.id)">
              <i class="fa-regular fa-ellipsis-v dropdown__toggle-icon--font-size-16"></i>
            </button>
            <div appDropdownMenu>
              <button type="button" appDropdownItem (click)="updateClick.emit(folder)" [disabled]="!isEditorParent && !isEditorMap[folder.id]">
                <i class="fa-regular fa-pen-to-square"></i>
                {{ 'button.rename' | translate }}
              </button>
              <button type="button" appDropdownItem (click)="shareClick.emit(folder)" [disabled]="!isEditorParent && !isEditorMap[folder.id]">
                <i class="fa-regular fa-share-from-square"></i>
                {{ 'button.share' | translate }}
              </button>
              <button type="button" appDropdownItem (click)="folderClick.emit(folder)" [disabled]="!isEditorParent && !isEditorMap[folder.id]">
                <i class="fa-regular fa-archive"></i>
                {{ 'button.archive' | translate }}
              </button>
              <hr class="dropdown-divider" />
              <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteClick.emit(folder)" [disabled]="!isEditorParent && !isEditorMap[folder.id]">
                <i class="fa-regular fa-trash"></i>
                {{ 'button.exclude' | translate }}
              </button>
            </div>
          </div>
        }
        <div class="folder-icon-holder">
          @if (folder.children_counter > 0) {
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
              <path
                d="M42.5 31.25H15C14.3125 31.25 13.75 30.6875 13.75 30V12.5C13.75 11.8125 14.3125 11.25 15 11.25H24.1797C24.5078 11.25 24.8281 11.3828 25.0625 11.6172L27.1328 13.6875C28.7734 15.3281 31 16.25 33.3203 16.25H42.5C43.1875 16.25 43.75 16.8125 43.75 17.5V30C43.75 30.6875 43.1875 31.25 42.5 31.25ZM15 35H42.5C45.2578 35 47.5 32.7578 47.5 30V17.5C47.5 14.7422 45.2578 12.5 42.5 12.5H33.3203C31.9922 12.5 30.7188 11.9766 29.7812 11.0391L27.7109 8.96094C26.7734 8.02344 25.5 7.5 24.1719 7.5H15C12.2422 7.5 10 9.74219 10 12.5V30C10 32.7578 12.2422 35 15 35ZM6.25 14.375C6.25 13.3359 5.41406 12.5 4.375 12.5C3.33594 12.5 2.5 13.3359 2.5 14.375V31.875C2.5 37.7422 7.25781 42.5 13.125 42.5H38.125C39.1641 42.5 40 41.6641 40 40.625C40 39.5859 39.1641 38.75 38.125 38.75H13.125C9.32812 38.75 6.25 35.6719 6.25 31.875V14.375Z"
                fill="url(#paint0_linear_9515_7247)"
              />
              <defs>
                <linearGradient id="paint0_linear_9515_7247" x1="25" y1="7.5" x2="25" y2="42.5" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#88CBFF" />
                  <stop offset="1" stop-color="#0A52EB" />
                </linearGradient>
              </defs>
            </svg>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
              <path
                d="M5 12.5C5 9.74219 7.24219 7.5 10 7.5H20.3203C21.8125 7.5 23.2422 8.09375 24.2969 9.14844L27.6484 12.5H40C42.7578 12.5 45 14.7422 45 17.5V37.5C45 40.2578 42.7578 42.5 40 42.5H10C7.24219 42.5 5 40.2578 5 37.5V12.5ZM10 11.25C9.3125 11.25 8.75 11.8125 8.75 12.5V37.5C8.75 38.1875 9.3125 38.75 10 38.75H40C40.6875 38.75 41.25 38.1875 41.25 37.5V17.5C41.25 16.8125 40.6875 16.25 40 16.25H27.3906C26.5625 16.25 25.7656 15.9219 25.1797 15.3359L21.6484 11.7969C21.2969 11.4453 20.8203 11.25 20.3203 11.25H10Z"
                fill="url(#paint0_linear_9515_3802)"
              />
              <defs>
                <linearGradient id="paint0_linear_9515_3802" x1="25" y1="7.5" x2="25" y2="42.5" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#88CBFF" />
                  <stop offset="1" stop-color="#0A52EB" />
                </linearGradient>
              </defs>
            </svg>
          }
        </div>
        <div class="folder-name-holder">
          <div class="folder-name">{{ folder.name }}</div>
        </div>
        <a [routerLink]="getFolderPath(folder.id)" class="folder__link"></a>
      </div>
    }
  </div>

  @if (!hidePagination) {
    <button type="button" class="btn-M btn-text icon-start d-flex mx-auto my-2" (click)="loadPageClick.emit()">
      <i class="fa-solid fa-rotate-reverse"></i>
      {{ 'documents.loadMoreFolders' | translate }}
    </button>
  }
}
